<template>
  <div>
    <div class="select-box flex" @click="show">
      <div class="flex-1">省市</div>
      <div class="text">
        {{ showText ? showText : '请选择' }}
        <van-icon name="arrow" />
      </div>
    </div>
    <van-popup v-model:show="showAddrPopup" position="bottom" round>
      <van-area
        :area-list="areaList"
        :columns-num="2"
        title="请选择"
        @cancel="onCancel"
        @change="change"
        @confirm="ononfirm"
      />
    </van-popup>
  </div>
</template>
<script>
  import store from '@/store'
  export default {
    // model: {
    //   prop: 'data',
    //   event: 'cc',
    // },
    props: {
      data: {
        type: String || Object,
        default: '',
      },
    },
    data() {
      return {
        showAddrPopup: false,
        selectText: '',
        showText: '',
        areaList: {
          province_list: {
            // 110000: '北京市',
            // 120000: '天津市',
          },
          city_list: {
            // 110100: '北京市',
            // 120100: '天津市',
          },
        },
      }
    },
    watch: {
      data: {
        handler(val) {
          this.showText = val
        },
        immediate: true,
      },
    },
    created() {
      this.getData()
    },
    methods: {
      init() {},
      show() {
        this.showAddrPopup = true
      },
      onCancel() {
        this.showAddrPopup = false
      },
      ononfirm() {
        this.showAddrPopup = false
        // 点确定时没有选中则默认是北京市
        if (!this.selectText) {
          this.selectText = '北京市,北京市'
        }
        this.showText = this.selectText
        this.$emit('update:data', this.selectText)
      },
      change(val) {
        //console.log('change', val)
        this.selectText = val
          .map((item) => {
            return item.name
          })
          .join(',')
      },
      getData() {
        const areaList = { province_list: {}, city_list: {} }
        store
          .dispatch('system/GetProvinceCityTree')
          .then((data) => {
            const { Code, Data } = data
            if (Code === 0) {
              Data.forEach((item) => {
                areaList.province_list[item.RegionId] = item.RegionName
                item.Children.forEach((item2) => {
                  areaList.city_list[item2.RegionId] = item2.RegionName
                })
              })
              this.areaList = areaList
            }
          })
          .catch((e) => {
            this.Toast('获取省市失败')
          })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .select-box {
    border: 1px solid #dde5ed;
    border-radius: 4px;
    padding: 10px 16px;
  }
  .text {
    color: #969799;
  }
</style>
